import type { MentiErrorOptions } from '@mentimeter/error-utils/error';
import { MentiError } from '@mentimeter/error-utils/error';
import type { StaticContentEntity as StaticContentSchema } from '@core-api/editor/types/response';

export class MismatchedSlideTypePropertyError<
  T extends StaticContentSchema = any,
> extends MentiError {
  constructor(
    expectedType: T['type'],
    actualType: StaticContentSchema['type'],
    options?: Partial<MentiErrorOptions> | undefined,
  ) {
    const message = `Requested ${expectedType} is not a ${expectedType}: ${actualType}`;
    super(message, {
      feature: 'compatibility-layer',
      ...options,
    });
    this.name = 'MismatchedSlideTypePropertyError';
  }
}
